import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  TablePagination,
  Grid,
  Paper,
  TextField,
} from "@mui/material";
import ReactDOM from "react-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
// import EventBusyIcon from "@mui/icons-material/EventBusy";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useSnackbar } from "../../Snackbar/SnackbarContext";
import apiEndpoints from "../../../apiconfig";
import DeleteConfirmDialog from "../../DeleteConfirmDialog";


export default function ViewStaffAttendance() {
  const navigate = useNavigate();

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  /* ---------------- MOCK DATA ---------------- */
const { showSnackbar } = useSnackbar();

const [records, setRecords] = useState([]);
const [loading, setLoading] = useState(true);
const [deleteDialog, setDeleteDialog] = useState({
  open: false,
  date: null,
});
 const [editData, setEditData] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const toggleStatus = (staffGuid, status) => {
    setEditData((prev) => ({
      ...prev,
      staff: prev.staff.map((s) =>
        s.staff_guid === staffGuid
          ? { 
              ...s, 
              status, 
              remarks: status === "present" ? "" : s.remarks,
              check_in: status === "absent" ? "" : s.check_in,
              check_out: status === "absent" ? "" : s.check_out
            }
          : s
      ),
    }));
  };

useEffect(() => {
  fetch(`${apiEndpoints.staffAttendance}?action=get`, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      if (!res.status) {
        showSnackbar(res.message, "error");
        return;
      }

      setRecords(res.data.data);
      setLoading(false);
    });
}, []);


const updateAttendance = () => {
  const payload = {
    date: editData.date,
    records: editData.staff.map((s) => ({
      staff_guid: s.staff_guid,
      status: s.status,
      remarks: s.remarks || "",
      check_in: s.check_in || "",
      check_out: s.check_out || "",
    })),
  };

  fetch(`${apiEndpoints.staffAttendance}?action=update`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((res) => {
      if (!res.status) {
        showSnackbar(res.message, "error");
        return;
      }

      showSnackbar("Attendance updated successfully", "success");

      setRecords((prev) =>
        prev.map((r) =>
          r.date === editData.date
            ? {
                ...r,
                staff: editData.staff.map((s) => {
                  let total_hours = null;
                  if (s.status === "present" && s.check_in && s.check_out) {
                    const [h1, m1] = s.check_in.split(":").map(Number);
                    const [h2, m2] = s.check_out.split(":").map(Number);
                    const diffMinutes = (h2 * 60 + m2) - (h1 * 60 + m1);
                    total_hours = diffMinutes > 0 ? Number((diffMinutes / 60).toFixed(2)) : 0;
                  }
                  return { ...s, total_hours };
                }),
              }
            : r
        )
      );

      setEditData(null);
    });
};

const deleteAttendance = (date) => {
  fetch(`${apiEndpoints.staffAttendance}?action=delete&date=${date}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      if (!res.status) {
        showSnackbar(res.message, "error");
        return;
      }

      showSnackbar("Attendance deleted", "success");
      setRecords((prev) => prev.filter((r) => r.date !== date));
    });
};




if (loading) {
  return <Typography>Loading attendance...</Typography>;
}
  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: 3,
        background: "rgba(255,255,255,0.25)",
        backdropFilter: "blur(10px)",
      }}
    >
      {/* HEADER */}
      <Grid
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h4" fontWeight={700} mb={3}>
          Staff Attendance
        </Typography>

        <Button
          variant="contained"
          sx={{ mb: 2, borderRadius: 999, px: 3 }}
          onClick={() => navigate("/admin/staff-markattendance")}
        >
          Mark Attendance
        </Button>
      </Grid>

      {/* TABLE CARD */}
      <Card
        sx={{
          p: 2,
          borderRadius: 4,
          background: "rgba(255,255,255,0.5)",
          backdropFilter: "blur(16px)",
          overflowX: "auto",
        }}
      >
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Total</TableCell>
              <TableCell>Present</TableCell>
              {/* <TableCell>Late</TableCell>
              <TableCell>Leave</TableCell> */}
              <TableCell>Absent</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {records
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((rec) => {
                const present = rec.staff.filter(
                  (s) => s.status === "present"
                ).length;
                // const late = rec.staff.filter(
                //   (s) => s.status === "late"
                // ).length;
                // const leave = rec.staff.filter(
                //   (s) => s.status === "leave"
                // ).length;
                const absent = rec.staff.filter(
                  (s) => s.status === "absent"
                ).length;

                return (
                  <TableRow key={rec.id}>
                    <TableCell>{rec.date}</TableCell>
                    <TableCell>{rec.staff.length}</TableCell>
                    <TableCell>
                      <Chip
                        label={present}
                        color="success"
                        variant="outlined"
                      />
                    </TableCell>
                    {/* <TableCell>
                      <Chip label={late} color="warning" variant="outlined" />
                    </TableCell>
                    <TableCell>
                      <Chip label={leave} color="info" variant="outlined" />
                    </TableCell> */}
                    <TableCell>
                      <Chip label={absent} color="error" variant="outlined" />
                    </TableCell>
                    <TableCell>
                      <IconButton onClick={() => setEditData(rec)}>
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() =>
                          setDeleteDialog({
                            open: true,
                            date: rec.date,
                          })
                        }
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>

        {/* PAGINATION */}
        <TablePagination
          component="div"
          count={records.length}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Card>

      {/* EDIT SLIDE PANEL (SAME AS STUDENT) */}
      {editData &&
        ReactDOM.createPortal(
          <Box
            sx={{
              position: "fixed",
              inset: 0,
              zIndex: 2000,
              bgcolor: "rgba(15,23,42,0.45)",
              backdropFilter: "blur(5px)",
              WebkitBackdropFilter: "blur(12px)",
              display: "flex",
              justifyContent: "flex-end",
            }}
            onClick={() => setEditData(null)}
          >
            <Box
              sx={{
                width: { xs: "100%", sm: "80%", md: "55%" },
                height: "100vh",
                p: { xs: 2, md: 3 },
                boxSizing: "border-box",
                display: "flex",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Paper
                elevation={6}
                sx={{
                  position: "relative",
                  width: "100%",
                  maxHeight: "67vh",
                  minHeight: "auto",
                  borderRadius: 4,
                  p: { xs: 3, md: 4 },
                  bgcolor: "rgba(255,255,255,0.96)",
                  backdropFilter: "blur(18px)",
                  overflowY: "auto",
                  boxShadow: "0 18px 45px rgba(15, 23, 42, 0.35)",
                  animation: "slideIn 0.35s ease",

                  // 👇 This moves card down (responsive)
                  mt: { xs: "18vh", sm: "12vh", md: "10vh" },
                }}
              >
                <IconButton
                  sx={{ position: "absolute", top: 12, right: 12 }}
                  onClick={() => setEditData(null)}
                >
                  <CloseIcon />
                </IconButton>

                <Typography variant="h5" fontWeight={700}>
                  Edit Staff Attendance
                </Typography>

                <Typography variant="body2" color="text.secondary" mb={2}>
                  Date: {editData.date}
                </Typography>
                <Divider sx={{ mb: 2 }} />
                <Box sx={{ flex: 1, overflowY: "auto", mb: 2 }}>
                  {editData.staff.map((s) => {
                    const isPresent = s.status === "present";
                    
                    // Calculate total hours dynamically
                    let displayHours = "";
                    if (isPresent && s.check_in && s.check_out) {
                      const [h1, m1] = s.check_in.split(":").map(Number);
                      const [h2, m2] = s.check_out.split(":").map(Number);
                      const diffMinutes = (h2 * 60 + m2) - (h1 * 60 + m1);
                      if (diffMinutes > 0) {
                        displayHours = (diffMinutes / 60).toFixed(2) + " hrs";
                      } else {
                        displayHours = "0 hrs";
                      }
                    }

                    return (
                      <Box
                        key={s.staff_guid}
                        sx={{
                          p: 2,
                          mb: 2,
                          borderRadius: 3,
                          background: "rgba(255,255,255,0.7)",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          border: "1px solid #E2E8F0"
                        }}
                      >
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                          <Box>
                            <Typography fontWeight={600}>{s.name}</Typography>
                            <Typography variant="caption">{s.role}</Typography>
                          </Box>

                          <Box sx={{ display: "flex", gap: 1 }}>
                            <Chip
                              icon={<CheckCircleIcon />}
                              label="Present"
                              color={isPresent ? "success" : "default"}
                              onClick={() => toggleStatus(s.staff_guid, "present")}
                            />
                            <Chip
                              icon={<CancelIcon />}
                              label="Absent"
                              color={!isPresent ? "error" : "default"}
                              onClick={() => toggleStatus(s.staff_guid, "absent")}
                            />
                          </Box>
                        </Box>

                        {isPresent && (
                          <Box display="flex" alignItems="center" gap={1.5}>
                            {!s.check_in && (
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{ borderRadius: 2 }}
                                onClick={() =>
                                  setEditData((prev) => ({
                                    ...prev,
                                    staff: prev.staff.map((item) =>
                                      item.staff_guid === s.staff_guid
                                        ? { ...item, check_in: getCurrentTime() }
                                        : item
                                    ),
                                  }))
                                }
                              >
                                Check-In
                              </Button>
                            )}

                            {s.check_in && !s.check_out && (
                              <Box display="flex" alignItems="center" gap={1}>
                                <Chip label={`In: ${s.check_in}`} variant="outlined" size="small" />
                                <Button
                                  variant="contained"
                                  color="secondary"
                                  size="small"
                                  sx={{ borderRadius: 2 }}
                                  onClick={() =>
                                    setEditData((prev) => ({
                                      ...prev,
                                      staff: prev.staff.map((item) =>
                                        item.staff_guid === s.staff_guid
                                          ? { ...item, check_out: getCurrentTime() }
                                          : item
                                      ),
                                    }))
                                  }
                                >
                                  Check-Out
                                </Button>
                              </Box>
                            )}

                            {s.check_in && s.check_out && (
                              <Box display="flex" alignItems="center" gap={1}>
                                <Chip label={`In: ${s.check_in}`} variant="outlined" size="small" />
                                <Chip label={`Out: ${s.check_out}`} variant="outlined" size="small" />
                                {displayHours && (
                                  <Chip
                                    label={displayHours}
                                    color="primary"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                )}
                              </Box>
                            )}

                            {(s.check_in || s.check_out) && (
                              <Button
                                variant="text"
                                color="error"
                                size="small"
                                onClick={() =>
                                  setEditData((prev) => ({
                                    ...prev,
                                    staff: prev.staff.map((item) =>
                                      item.staff_guid === s.staff_guid
                                        ? { ...item, check_in: "", check_out: "" }
                                        : item
                                    ),
                                  }))
                                }
                                sx={{ minWidth: "auto", p: 0.5 }}
                              >
                                Reset
                              </Button>
                            )}
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>

                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}
                >
                  <Button
                    onClick={() => setEditData(null)}
                    sx={{
                      borderRadius: 999,
                      px: 4,
                      fontWeight: 600,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    onClick={updateAttendance}
                    sx={{
                      borderRadius: 999,
                      px: 4,
                      fontWeight: 600,
                    }}
                  >
                    Update Attendance
                  </Button>
                </Box>
              </Paper>
            </Box>
          </Box>,
          document.body
        )}
      <DeleteConfirmDialog
        open={deleteDialog.open}
        title="Delete Attendance"
        message="Are you sure you want to delete this staff attendance record? This action cannot be undone."
        onClose={() => setDeleteDialog({ open: false, date: null })}
        onConfirm={() => {
          deleteAttendance(deleteDialog.date);
          setDeleteDialog({ open: false, date: null });
        }}
      />
    </Box>
  );
}
